angular
    .module("skillBuilderSaaS")
    .directive("icheck", (["$timeout", function ($timeout) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function ($scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs["value"];
                    $scope.$watch($attrs["ngModel"], function () {
                        $(element).iCheck("update");
                    });
                    //$scope.$watch($attrs["ngDisabled"], function (newValue) {
                    //	$(element).iCheck(newValue ? "disable" : "enable");
                    //	$(element).iCheck("update");
                    //});
                    return $(element).iCheck({
                        checkboxClass: "icheckbox_flat",
                        radioClass: "iradio_flat"
                    }).on("ifChanged", function (event) {
                        if ($(element).attr("type") === "checkbox" && $attrs["ngModel"]) {
                            $scope.$apply(function () {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr("type") === "radio" && $attrs["ngModel"]) {
                            return $scope.$apply(function () {
                                return ngModel.$setViewValue(value);
                            });
                        }
                        return "";
                    });
                });
            }
        };
    }]));
